<template>
  
    <content-header
        icona="fas fa-hard-hat"
        titolo="Operatori"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-body">
             <!-- *** GRIGLIA UTENTI *** -->
            <div class="card" v-if="mostraGrigliaUtente">
            <div class="card-body">
                <button type="button" class="btn btn-dark" @click="GetListsnL_Utenti()">
                    <i class="fas fa-sync"></i>&nbsp;
                </button>&nbsp;
                <button type="button" class="btn btn-success" @click="AttivaEditUtente">
                <i class="fas fa-plus"></i>&nbsp;Nuovo utente
                </button>
                <br /><br />

                <div class="row">
                <div class="col-md-4">
                    <input type="text" class="form-control" placeholder="cerca per nome, cognome, nome utente..." v-model="reqGriglia.Testuale" @keyup.enter="Cerca" />
                </div>
                <div class="col-md-1">
                    <a class="btn btn-info" @click="GetListsnL_Utenti">
                    <font-awesome-icon icon="fa-solid fa-search"></font-awesome-icon>&nbsp;Cerca
                    </a>
                </div>
                </div>  
                
                <br/>
                <griglia-facile
                :colonne-header="g_colonneHeader"
                :colonne="g_colonne"
                :colonneNoOrder="g_colonneNoOrder"
                :colonneAlign="g_colonneAlign"
                :comandi="g_comandi"
                :mostraPager="true"
                classi-table="table-sm table-hover table-custom"
                :dati="dtUtenti"
                :queryLength="g_queryLength"
                :currentPage="g_currentPage"
                
                @Seleziona="SelectUtente"
                @Cancella="DelElemUtente"
                @Ordina="OrdinaGriglia"
                @Disattiva="DisattivaUtente"
                @CambiaElementi="CambiaElementi"
                @Precedente="PaginaPrecendente"
                @Successiva="PaginaSuccessiva"
                @CambiaPagina="CambiaPagina"
                
                fontawesome="standard"

                ></griglia-facile>



                
            </div>
            </div>


            <!-- *** EDIT UTENTE *** -->
            <div class="card" v-if="mostraEditUtente">
            <div class="card-header">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvasnL_Utenti(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvasnL_Utenti(false)">Salva e Chiudi</button>
            </div>
            <div class="card-body">
                <messaggio-standard 
                    :mostraMessaggio="mostraMessaggio"
                    :alertClass="alertClass"
                    :alertIcon="alertIcon"
                    :alertIconSpin="alertIconSpin"
                    :alertMessaggio="alertMessaggio"
                    fontawesome="standard"
                    ></messaggio-standard>

                <form autocomplete="off">
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-info text-primary"></i>&nbsp;Dati generali
                    </div>
                </div>

                <div class="card-body">
                <div class="row">
                    <div class="col-md">
                    <div class="form-group">
                        <label>Cognome</label>
                        <input type="text" class="form-control" v-model="oUtente.ute_cognome">
                    </div>
                    </div>
                    <div class="col-md">
                    <div class="form-group">
                        <label>Nome</label>
                        <input type="text" class="form-control" v-model="oUtente.ute_nome">
                    </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md">
                    <div class="form-group">
                        <label>Username (UID)</label>
                        <input type="text" class="form-control" v-model="oUtente.ute_uid">
                    </div>
                    </div>
                    <div class="col-md">
                    <div class="form-group">
                        <label>Password</label>
                        <input type="password" class="form-control" v-model="oUtente.ute_password">
                    </div>
                    <div id="divPass"></div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md">
                    <div class="form-group">
                        <label>Livello</label>
                        <select class="form-control"  v-model="oUtente.ute_idLivello">
                            <option v-for="l in dtLivelli" :key="l.lvl_id" :value="l.lvl_id">{{ l.lvl_descrizione }}</option>
                        </select>
                    </div>
                    </div>
                    <div class="col-md">
                    <div class="form-group">
                        <label>Gruppi (Opzionale)</label>
                        <select class="form-control" multiple="true" v-model="oUtente.gruppi">
                            <option v-for="g in dtGruppi" :key="g.grp_id" :value="g.grp_id">{{ g.grp_descrizione }}</option>
                        </select>
                    </div>
                    </div>
                </div>
                

                <!-- CAMPI CUSTOM -->
                <!-- <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-stream text-dark"></i>&nbsp;Campi custom
                    </div>
                </div> -->
                


                
                

                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-cog text-dark"></i>&nbsp;Opzioni
                    </div>
                </div>

                <div class="form-group">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="oUtente.ute_attivo" />Attivo
                        </label>
                    </div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox"  v-model="oUtente.ute_usaDataScadenzaPassword" />Usa scad. pass
                            <input type="date" class="form-control" v-model="oUtente.ute_dataScadenzaPassword" />
                        </label>
                    </div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="oUtente.ute_permettiCambioPassword"  />Permetti cambio password
                        </label>
                    </div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="oUtente.ute_usaDataScadenzaAccount"/>Usa scadenza account
                            <input type="date" class="form-control" v-model="oUtente.ute_dataScadenzaAccount" />
                        </label>
                    </div>
                </div>
                </div>
            </form>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvasnL_Utenti(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvasnL_Utenti(false)">Salva e Chiudi</button>
            </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import ContentHeader from '@/components/layout/ContentHeader.vue';
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'OperatoriView',
    components: {
        ContentHeader, GrigliaFacile, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
        dtUtenti: [],
        dtLivelli: [],
        dtGruppi:[],
        dtUtentiStruct: [],
        dtTecnici: [],

        //Impostazioni griglia
        g_colonne: ['ute_id','ute_cognome','ute_nome','ute_uid', 'ute_attivo', 'lvl_descrizione'],
        g_colonneHeader: ['Id', 'Cognome', 'Nome', 'Uid', 'Stato', 'Livello'],
        g_colonneNoOrder: [], //'ute_attivo'
        g_colonneAlign: [],
        g_comandi: 
        [
            {titolo:'Cancella', icona:'fa-trash', iconaStile: 'btn btn-xs btn-outline-danger', emetti: 'Cancella'},
            //{titolo:'Disattiva', icona:'fa-eye', iconaStile: 'btn btn-sm btn-outline-info', emetti: 'Disattiva'}
        ],
        g_queryLength: 0, //lunghezza della query (che NON è la lunghezza del dataset passato)
        g_currentPage: 1, //pagina corrente

        //Oggetto richiesta griglia
        reqGriglia: {
            ele_pag: 10,
            start: 0,
            orderColumn: "ute_uid",
            orderDir:"ASC",
            token: "",
            //Campi custom
            Testuale: ""
        },

        mostraGrigliaUtente: true,
        mostraEditUtente: false,

        oUtente: {

        },

        oUtenteCustom: { 
            idTecnico: "-1",
        },

        mostraMessaggio: false,
        alertMessaggio: "",
        alertClass: "",     
        alertIcon: "",
        alertIconSpin: false

        
        }
    },
    methods: {
        // GESTIONE PANNELLI E PULIZIA INPUT
        AttivaGriglia() {
            this.mostraEditUtente = false;
            this.mostraGrigliaUtente = true;

            this.GetListsnL_Utenti();
        },
        AttivaEditUtente() {
            this.mostraEditUtente = true;
            this.mostraGrigliaUtente = false;

            this.ClearMessaggio();
            this.ClearUtente();
        },
        ClearUtente() {
            this.oUtente = {
                ute_id : -1,
                ute_nome : "",
                ute_cognome : "",
                ute_uid : "",
                ute_password : "",
                ute_attivo : true,
                ute_idLivello : 2,
                ute_cambioPassword : false,
                ute_dataScadenzaAccount : undefined,
                ute_dataScadenzaPassword : undefined,
                ute_usaDataScadenzaAccount : false,
                ute_usaDataScadenzaPassword : false,
                ute_email : "",
                ute_telefono : "",
                ute_cellulare : "",
                ute_notificheViaEmail : false,
                ute_permettiCambioPassword : true,

                campiCustom: [],

                token: "",
            }
        },
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },

        // OPERAZIONI DI BASE SU UTENTI
        // lista utenti
        GetListsnL_Utenti() {
        //Carica lista elementi
        this.$store.commit('Messaggio', {parms: [true, ['Caricamento griglia in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
        fetch(this.cfg.apisrv + "/api/User/GetListUtenti" , {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.reqGriglia)
            }).then(response => response.json())
            .then(obj => {
                if(obj.status == "OK") {
                    this.dtUtenti = obj.moreJsonData;
                    this.g_queryLength = parseInt(obj.dati[0], 10);
                    if(this.reqGriglia.Testuale != "") this.EvidenzaRicerca();
                    this.$store.commit('Messaggio', {parms: [true, ['Griglia caricata.'], 'alert alert-success', 'fa-check', false, 2000]});
                } else {
                    this.$store.commit('Messaggio', {parms: [true, ['Errore caricamento griglia.'], 'alert alert-danger', 'fa-times', false, 2000]});
                }
                
            });
        },
        //utente
        SelectUtente(o)  {
            if(o.ute_idLivello!=0) {
                this.GetElemsnL_Utenti(o.ute_id);
            } else {
                this.$store.commit('Messaggio', {parms: [true, ['Non è possibile modificare SuperAdmin.'], 'alert alert-danger', 'fa-times', false, 3000]});
            }
        
        },
        GetElemsnL_Utenti(idelem) {
            //Carica elemento singolo
            fetch(this.cfg.apisrv + "/api/User/GetElemUtenti?token=" + this.$store.state.UserInfo.token + "&idute=" + idelem)
            .then(response => response.json())
            .then(obj => {
                
                //Proprietà custom
                for(let i = 0; i<obj.campiCustom.length; i++) {
                    if(obj.campiCustom[i].cus_key == 'idTecnico') {
                    this.oUtenteCustom.idTecnico = obj.campiCustom[i].cus_value;
                    }
                }
                
                this.oUtente = obj;

                this.mostraGrigliaUtente=false;
                this.mostraEditUtente= true;

                

                this.$store.commit('Messaggio', {parms: [true, ['Utente caricato.'], 'alert alert-success', 'fa-check', false, 2000]});

                //this.GetListsnL_Utenti();
            });
        },
        SalvasnL_Utenti(reload) {
            let oSubmit = [];
            oSubmit = this.oUtente;
            oSubmit.token = this.$store.state.UserInfo.token;

            //Proprietà custom
            oSubmit.campiCustom = [
            {
                cus_idUtente: -1,
                cus_key : 'idTecnico',
                cus_value: this.oUtenteCustom.idTecnico + ''
            }
            ];
        

            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/User/SalvaUtente", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        if(reload)  {
                            //this.oUtente = obj.moreJsonData;
                            this.GetElemsnL_Utenti(obj.dati[0]);
                        }
                        else {
                            //Fa redirect
                            this.AttivaGriglia();
                        }
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = obj.dati;
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false
                    }
                });

        },
        DelElemUtente(o) {
        //Cancella elemento singolo
        if(confirm("Cancellare l'elemento?")) {
                fetch(this.cfg.apisrv + "/api/User/DelElemUtente?token=" + this.$store.state.UserInfo.token + "&idute=" + o.ute_id)
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                    this.$store.commit('Messaggio', {parms: [true, ['Utente cancellato.'], 'alert alert-success', 'fa-check', false, 2000]});

                    this.GetListsnL_Utenti();
                    }
                    else {
                    this.$store.commit('Messaggio', {parms: [true, obj.dati, 'alert alert-danger', 'fa-times', false, 3000]});
                    }
                    
                });
            }
        },
        // ordina la griglia  
        OrdinaGriglia(i) {
        if(this.reqGriglia.orderColumn == this.g_colonne[i]) {
            //Stessa colonna
            if(this.reqGriglia.orderDir == 'DESC') {this.reqGriglia.orderDir = 'ASC';}
            else {this.reqGriglia.orderDir = 'DESC';}
        }
        else {
            //altra colonna
            this.reqGriglia.orderColumn = this.g_colonne[i];
            this.reqGriglia.orderDir = 'DESC';
            
        }
        
        this.GetListsnL_Utenti();

        },

        //ALTRI DATASET
        GetListsnL_LivelliUtente() {
        //Carica lista elementi
        fetch(this.cfg.apisrv + "/api/User/GetListLivelli?token=" + this.$store.state.UserInfo.token )
            .then(response => response.json())
            .then(obj => {
                this.dtLivelli = obj;
            });
        },
        GetListsnL_Gruppi() {
        //Carica lista elementi
        fetch(this.cfg.apisrv + "/api/User/GetListGruppi?token=" + this.$store.state.UserInfo.token )
            .then(response => response.json())
            .then(obj => {
                this.dtGruppi = obj;
            });
        },
        GetListUtentiStruct() {
        //Carica lista elementi
        fetch(this.cfg.apisrv + "/api/User/GetListUtentiStruct?token=" + this.$store.state.UserInfo.token)
            .then(response => response.json())
            .then(obj => {
                this.dtUtentiStruct = obj;
            });
        },


        //PAGINAZIONE GRIGLIA
        CambiaElementi(nrElem) {
        this.reqGriglia.ele_pag = nrElem;
        this.GetListsnL_Utenti();
        },
        PaginaPrecendente() {
        this.reqGriglia.start = this.reqGriglia.start - parseInt(this.reqGriglia.ele_pag, 10);
        this.g_currentPage--;
        this.GetListsnL_Utenti();  
        
        },
        PaginaSuccessiva() {
        this.reqGriglia.start = this.reqGriglia.start + parseInt(this.reqGriglia.ele_pag, 10);
        this.g_currentPage++;
        this.GetListsnL_Utenti();
        
        },
        CambiaPagina(pag) {
        this.reqGriglia.start = (parseInt(this.reqGriglia.ele_pag, 10) * pag) - parseInt(this.reqGriglia.ele_pag, 10);
        this.g_currentPage = pag;
        this.GetListsnL_Utenti();
        },
        Cerca() {
        this.reqGriglia.start = 0;
        this.GetListsnL_Utenti();
        },
    
    

        //ALTRE FUNZIONI
        
        EvidenzaRicerca() {
        for(let i=0; i<this.dtUtenti.length;i++){
            this.dtUtenti[i].ute_cognome = snFunctions.EvidenziaTesto(this.dtUtenti[i].ute_cognome, this.reqGriglia.Testuale, "spn-evidenziato");
            this.dtUtenti[i].ute_nome = snFunctions.EvidenziaTesto(this.dtUtenti[i].ute_nome, this.reqGriglia.Testuale, "spn-evidenziato");
            this.dtUtenti[i].ute_uid = snFunctions.EvidenziaTesto(this.dtUtenti[i].ute_uid, this.reqGriglia.Testuale, "spn-evidenziato");
        }
        },
    
    
    },
    computed: {
        
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.reqGriglia.token = this.$store.state.UserInfo.token;

        this.GetListsnL_LivelliUtente();
        this.GetListsnL_Gruppi();
        this.GetListsnL_Utenti();
        this.GetListUtentiStruct();

    }
}
</script>